<template>
	<div class="relative xl:min-w-[500px]">
		<Combobox :model-value="searchTerm">
			<ComboboxInput
				ref="inputRef"
				class="w-full flex overflow-hidden relative grow rounded-md bg-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset"
				:display-value="(option) => ''"
				placeholder="Search for products..."
				autocomplete="off"
				@change="change($event.target.value)"
				@keydown.down.prevent="highlightNext"
				@keydown.up.prevent="highlightPrevious"
				@keydown.enter.prevent="selectHighlighted"
				@focus="highlightedIndex = -1" />
			<ComboboxOptions
				v-if="options.length > 0"
				class="top-[40px] absolute mt-3 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto z-10">
				<!-- Products -->
				<ComboboxOption
					v-for="(option, index) in options"
					:key="index"
					:value="option"
					:class="[
						'px-4 py-2 cursor-pointer',
						index === highlightedIndex ? 'bg-blue-100' : 'hover:bg-blue-100'
					]"
					@click="selectOption(option)"
					@mouseenter="highlightedIndex = index">
					<div class="flex justify-between min-w-[400px]">
						<div>
							<div class="text-xs font-bold">{{ option.item_no }}</div>
							<div class="text-sm">{{ option.name }}</div>
						</div>
						<div class="flex items-center ml-2">
							<app-badge>{{ option.object }}</app-badge>
						</div>
					</div>
				</ComboboxOption>
			</ComboboxOptions>
		</Combobox>

		<div v-if="requests > 0" class="flex items-center absolute top-0 right-0 h-10">
			<app-loader></app-loader>
		</div>
	</div>

	<!--	<item-slideover-->
	<!--		:item="scannerStore.item"-->
	<!--		@closed="scannerStore.item = null"-->
	<!--	/>-->
</template>

<script lang="ts" setup>
	import { onMounted, onUnmounted, ref } from 'vue'

	// import useScannerStore from '@/stores/scanner'
	// import ItemSlideover from '@/components/partials/stock-id/ItemSlideover.vue'

	import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/vue'
	import { debounce } from 'lodash'
	import AppBadge from '@/components/base/AppBadge.vue'
	import AppLoader from '@/components/base/AppLoader.vue'
	import ProductService from '@/services/product'
	import { useRouter } from 'vue-router'
	
	const searchTerm = ref('')

	// const scannerStore = useScannerStore()

	const inputRef = ref(null)

	const services = [new ProductService()]

	const highlightedIndex = ref(-1)

	const options = ref([])

	let controller = new AbortController()

	const requests = ref(0)

	const router = useRouter()

	const change = (value) => {
		if (value.length >= 2) {
			search(value)
		} else {
			options.value = []
		}
	}

	const search = debounce(async (value) => {
		// Cancel the previous request
		controller.abort()
		controller = new AbortController()

		options.value = []

		services.forEach((service) => {
			requests.value++
			service
				.getAll({ filter: value })
				.then((res) => {
					console.log('API response from service:', res.data.data)
					options.value = [...options.value, ...res.data.data]
					console.log('Current options:', options.value)
				})
				.finally(() => {
					requests.value--
				})
		})
	}, 400)

	onMounted(() => {
		window.addEventListener('keydown', scanStart)
	})

	onUnmounted(() => {
		window.removeEventListener('keydown', scanStart)
		// window.removeEventListener("keyup", unfocus);
	})

	
	const scanStart = (event) => {
    // Only treat as scanner if: Unidentified key AND no element currently has focus
    // This prevents tablet touch events from accidentally focusing the search input
    if (event.key === 'Unidentified' && !document.activeElement) {
       inputRef.value?.$el?.focus()
       // window.addEventListener("keyup", unfocus);
    }
}

	// const unfocus = (event) => {
	// 	if(event.key === 'Unidentified') {
	// 		inputRef.value?.$el?.blur()
	// 	}
	// 	window.removeEventListener("keyup", unfocus);
	// }

	const highlightNext = () => {
		if (options.value.length === 0) return
		highlightedIndex.value = (highlightedIndex.value + 1) % options.value.length
		console.log(highlightedIndex.value)
	}

	const highlightPrevious = () => {
		if (options.value.length === 0) return
		highlightedIndex.value =
			(highlightedIndex.value - 1 + options.value.length) % options.value.length
	}

	const selectHighlighted = () => {
		if (highlightedIndex.value >= 0) {
			selectOption(options.value[highlightedIndex.value])
		}
	}

	const selectOption = (option) => {
		console.log('Selected option:', option)
		searchTerm.value = option

		if (option.object === 'product') {
			console.log('Navigating to product:', option.id)
			router.push({ name: 'product-data.product', params: { id: option.id } })
		} else if (option.prgroup) {
			console.log('Navigating to product group (prgroup):', option.prgroup)
			router.push({ name: 'product-data.product-group', params: { code: option.prgroup } })
		} else if (option.product_group) {
			console.log('Navigating to product group (product_group):', option.product_group)
			router.push({ name: 'product-data.product-group', params: { code: option.product_group } })
		} else if (option.pgroup) {
			console.log('Navigating to product group (pgroup):', option.pgroup)
			router.push({ name: 'product-data.product-group', params: { code: option.pgroup } })
		} else {
			console.log('No navigation logic for this option type')
		}
		highlightedIndex.value = -1
		options.value = []
		// scannerStore.loadItem(option.itemNo)
	}
</script>
